import { render, staticRenderFns } from "./LogoutConfirmDialog.vue?vue&type=template&id=1cd00aaa&scoped=true"
import script from "./LogoutConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./LogoutConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LogoutConfirmDialog.vue?vue&type=style&index=0&id=1cd00aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd00aaa",
  null
  
)

export default component.exports